import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';
import PasswordField from './PasswordField';

jest.mock('components/styleguide/icon/Icon', () => {
  return {
    __esModule: true,
    default: ({ name, ...props }: any) => <span data-icon={name} {...props} />,
  };
});

describe('PasswordField', () => {
  it('renders a password input', () => {
    const { container } = render(<PasswordField value="" onChange={() => {}} />);
    const input = container.querySelector('input');
    expect(input).toHaveAttribute('type', 'password');
  });

  it('does not show hint when not focused, even if password does not meet minimum length', () => {
    render(<PasswordField value="short" hint="At least 8 characters" onChange={() => {}} />);
    expect(screen.queryByText('At least 8 characters')).not.toBeInTheDocument();
  });

  it('shows hint on focus when password does not meet minimum length', () => {
    const { container } = render(<PasswordField value="short" hint="At least 8 characters" onChange={() => {}} />);
    fireEvent.focus(container.querySelector('input')!);
    expect(screen.getByText('At least 8 characters')).toBeInTheDocument();
  });

  it('hides hint when password meets minimum length even while focused', () => {
    const { container } = render(<PasswordField value="longpassword" hint="At least 8 characters" onChange={() => {}} />);
    fireEvent.focus(container.querySelector('input')!);
    expect(screen.queryByText('At least 8 characters')).not.toBeInTheDocument();
  });

  it('hides hint when input loses focus', () => {
    const { container } = render(<PasswordField value="short" hint="At least 8 characters" onChange={() => {}} />);
    const input = container.querySelector('input')!;
    fireEvent.focus(input);
    expect(screen.getByText('At least 8 characters')).toBeInTheDocument();
    fireEvent.blur(input);
    expect(screen.queryByText('At least 8 characters')).not.toBeInTheDocument();
  });

  it('supports custom minLength', () => {
    const { container } = render(<PasswordField value="12345" minLength={5} hint="At least 5 characters" onChange={() => {}} />);
    fireEvent.focus(container.querySelector('input')!);
    expect(screen.queryByText('At least 5 characters')).not.toBeInTheDocument();
  });

  it('shows hint on focus when value is below custom minLength', () => {
    const { container } = render(<PasswordField value="1234" minLength={5} hint="At least 5 characters" onChange={() => {}} />);
    fireEvent.focus(container.querySelector('input')!);
    expect(screen.getByText('At least 5 characters')).toBeInTheDocument();
  });

  describe('visibility toggle', () => {
    it('renders eye icon button', () => {
      const { container } = render(<PasswordField value="" onChange={() => {}} />);
      const button = container.querySelector('button.iconRightContainer');
      expect(button).toBeInTheDocument();
      expect(button!.querySelector('[data-icon="eye"]')).toBeInTheDocument();
    });

    it('toggles to text type when clicking eye icon', () => {
      const { container } = render(<PasswordField value="secret" onChange={() => {}} />);
      const button = container.querySelector('button.iconRightContainer')!;

      fireEvent.click(button);
      const input = container.querySelector('input');
      expect(input).toHaveAttribute('type', 'text');
      expect(button.querySelector('[data-icon="eyeOff"]')).toBeInTheDocument();
    });

    it('toggles back to password type on second click', () => {
      const { container } = render(<PasswordField value="secret" onChange={() => {}} />);
      const button = container.querySelector('button.iconRightContainer')!;

      fireEvent.click(button);
      fireEvent.click(button);
      const input = container.querySelector('input');
      expect(input).toHaveAttribute('type', 'password');
      expect(button.querySelector('[data-icon="eye"]')).toBeInTheDocument();
    });

    it('does not render eye icon when disabled', () => {
      const { container } = render(<PasswordField value="" disabled onChange={() => {}} />);
      const button = container.querySelector('button.iconRightContainer');
      expect(button).not.toBeInTheDocument();
    });
  });

  it('shows error instead of hint', () => {
    render(<PasswordField value="short" hint="At least 8 characters" error="Password is required" onChange={() => {}} />);
    expect(screen.getByText('Password is required')).toBeInTheDocument();
    expect(screen.queryByText('At least 8 characters')).not.toBeInTheDocument();
  });
});
